import React from 'react';
import { Col, Row, View } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import { Button } from '@amzn/stencil-react-components/button';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import RouterLinkCard from './common/RouterLinkCard';

import SegmentIcon from '../img/segments-icon.png';
import CreateContentIcon from '../img/create-content-icon.png';
import SchedulingIcon from '../img/scheduling-icon.png';
import AnalyticsIcon from '../img/analytics-icon.png';
import ResourcesIcon from '../img/resources-icon.png';
import { FormattedMessage } from 'react-intl';
import {
  ANALYTICS_PAGE,
  CREATE_CONTENT_PAGE,
  RESOURCES_PAGE,
  SCHEDULING_LANDING_PAGE,
  SEGMENT_PAGE,
} from '../constants/routesConstant';
import { useUserInfo } from '../hooks/useUserInfo';
import { useDispatch } from 'react-redux';
import { getAllMessageTemplates, getAllSegments } from '../actions/nudgeActions';

import { IconQuestionCircleSmall } from '@amzn/stencil-react-icons';

const IconWithTooltip = withTooltip()(IconQuestionCircleSmall);

export const CreateSegmentLink = () => (
  <RouterLinkCard to={SEGMENT_PAGE} justifyContent="none">
    <Col alignItems="left">
      <Row gridGap="S300" alignItems="left">
        <Text fontSize={'T500'}>
          <FormattedMessage id="app.landing.segments" defaultMessage="Segments" />
        </Text>
        <IconWithTooltip title="Show tooltip" tooltipText="Create a segment" color="primary70" />
      </Row>
      <Row gridGap="S200">
        <div>
          <img src={SegmentIcon} />
        </div>
        <Text>
          <FormattedMessage
            id="app.landing.segmentDescription"
            defaultMessage="Segment Description"
          />
        </Text>
      </Row>
    </Col>
  </RouterLinkCard>
);

export const CreateContentLink = () => (
  <RouterLinkCard to={CREATE_CONTENT_PAGE} justifyContent="none">
    <Col alignItems="left">
      <Row gridGap="S300">
        <Text fontSize={'T500'}>
          <FormattedMessage id="app.landing.createContent" defaultMessage="Create content" />
        </Text>
        <IconWithTooltip
          title="Show tooltip"
          tooltipText="Create a message template for sending nudges"
          color="primary70"
        />
      </Row>
      <Row gridGap="S200">
        <div>
          <img src={CreateContentIcon} />
        </div>
        <Text>
          <FormattedMessage
            id="app.landing.createContentDescription"
            defaultMessage="Create content description"
          />
        </Text>
      </Row>
    </Col>
  </RouterLinkCard>
);

export const CreateSchedulingLink = () => (
  <RouterLinkCard to={SCHEDULING_LANDING_PAGE} justifyContent="none">
    <Row display="flex" width={'100%'} alignItems="center">
      <Col width={'80%'}>
        <Row gridGap="S300">
          <Text fontSize={'T500'}>
            <FormattedMessage id="app.landing.nudgeCampaign" defaultMessage="Nudge Campaign" />
          </Text>
          <IconWithTooltip
            title="Nudge campaign"
            tooltipText="Create a nudge campaign"
            color="primary70"
          />
        </Row>
        <Row gridGap="S200">
          <div>
            <img src={SchedulingIcon} />
          </div>
          <Text fontSize={'T200'}>
            <FormattedMessage
              id="app.landing.nudgeCampaignDescription"
              defaultMessage="Nudge campaign description"
            />
          </Text>
        </Row>
      </Col>
      <Col width={'20%'}>
        <Button data-testid="create-nudge-btn" variant="primary">
          <FormattedMessage
            id="app.landing.createANudgeCampaign"
            defaultMessage="Create a nudge campaign"
          />
        </Button>
      </Col>
    </Row>
  </RouterLinkCard>
);

export const ViewAnalyticsLink = () => (
  <RouterLinkCard to={ANALYTICS_PAGE} justifyContent="none">
    <Col alignItems="left">
      <Row gridGap="S300">
        <Text fontSize={'T500'}>
          <FormattedMessage id="app.landing.analytics" defaultMessage="Analytics" />
        </Text>
        <IconWithTooltip
          title="Show tooltip"
          tooltipText="This is the tooltip text."
          color="primary70"
        />
      </Row>
      <Row gridGap="S200">
        <div>
          <img src={AnalyticsIcon} />
        </div>
        <Text>
          <FormattedMessage
            id="app.landing.analyticsDescription"
            defaultMessage="Analytics description"
          />
        </Text>
      </Row>
    </Col>
  </RouterLinkCard>
);

export const ViewResourcesLink = () => (
  <RouterLinkCard to={RESOURCES_PAGE} justifyContent="none">
    <Col alignItems="left">
      <Row gridGap="S300">
        <Text fontSize={'T500'}>
          <FormattedMessage id="app.landing.resources" defaultMessage="Resources" />
        </Text>
        <IconWithTooltip
          title="Show tooltip"
          tooltipText="This is the tooltip text."
          color="primary70"
        />
      </Row>
      <Row gridGap="S200">
        <div>
          <img src={ResourcesIcon} />
        </div>
        <Text>
          <FormattedMessage
            id="app.landing.resourcesDescription"
            defaultMessage="Resource Description"
          />
        </Text>
      </Row>
    </Col>
  </RouterLinkCard>
);

const LandingPage = () => {
  return (
    <View gridGap={'S500'} padding={'15px'}>
      <Row flex={'100%'} width={'96%'} justifyContent={'flex-end'} margin={'0 0 20px 0'}>
        <CreateSchedulingLink />
      </Row>
      <Col gridGap="S400">
        <Row gridGap="S400" height={180}>
          <View backgroundColor="primary70" width={'47%'}>
            <CreateSegmentLink flex="100%" />
          </View>
          <View backgroundColor="pink70" width={'47%'}>
            <CreateContentLink />
          </View>
        </Row>
        <Row gridGap="S400" height={180}>
          <View backgroundColor="pink70" width={'47%'}>
            <ViewAnalyticsLink />
          </View>
          <View backgroundColor="pink70" width={'47%'}>
            <ViewResourcesLink />
          </View>
        </Row>
      </Col>
    </View>
  );
};
LandingPage.propTypes = {};

export default LandingPage;
